<div class="modal-container">
  <h1 i18n>Select tags</h1>
  <div class="input-wrapper">
    <app-multi-select [tags]="tags" [multiSelectType]="MultiSelectType.TAG" [showControlButtons]="false" [formControl]="tagControl">
    </app-multi-select>
  </div>

  <section class="buttons">
    <button class="close-button" (click)="closeModal()" i18n>Cancel</button>
    <button class="submit-button" (click)="saveTags()" i18n>Save selection</button>
  </section>
</div>
